import { connect } from "react-redux";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import when from "recompose/branch";
import renderNothing from "recompose/renderNothing";
import { withModel } from "../../data-providers/model";
import CartSummary from "./CartSummary";
import { getCart, isCartEmpty } from "../../../store/selectors/cart";
import { getValues } from "./helpers";

const enhance = compose(
  withModel,
  connect((state) => ({
    summary: getCart(state),
    isCartEmpty: isCartEmpty(state),
  })),
  when(
    (props) => props.isCartEmpty,
    renderNothing,
    (c) => c
  ),
  withProps((props) => ({
    paymentIconExclusions: ["apple_pay", "paypal_checkout"],
    values: getValues(props),
  }))
);

export default enhance(CartSummary);
